import type { AllRouteEndpoints } from "../routeTypes";

export const aiAgentDynamicPromptsAppGroupIdCacheKeys: AllRouteEndpoints[] = [
  "/ai_agent/dynamic_prompts/:app_group_id",
];
